<template>
    <form @submit.prevent="handleCompany">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ heading }}</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Name" :type="fieldType('name')" :message="getError('name')">
                    <o-input v-model="copy.name" />
                </o-field>

                <o-field label="Address" :type="fieldType('address')" :message="getError('address')">
                    <o-input v-model="copy.address" />
                </o-field>

                <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                    <o-input v-model="copy.email" />
                </o-field>

                <o-field label="Lead Owner">
                    <autocomplete-select type="user" v-model="copy.lead_owner" :error="getError('lead_owner')" />
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="handleClose">Close</button>
                <button class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import HandlesForm from './../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        data() {
            return {
                copy: {name: '', email: '', address: '', lead_owner: null}
            }
        },

        methods: {
            ...mapActions(['createOrUpdateCompany']),

            handleCompany () {
                let submit = this.wrapSubmit(this.createOrUpdateCompany)

                submit(this.copy)
                    .then(res => {
                        this.$emit('company-added', res.data.data.id)
                        this.$emit('modalButtonClick', res.data.data.id)
                        this.successMessage('Company was successfull ' + this.copy.id ? 'updated' : 'added')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            },
            handleClose() {
                this.$emit('modalButtonClick', null)
                this.$parent.$parent.$emit('update:active', false)
            }
        },

        computed: {
            ...mapGetters(['companies']),

            heading() {
                return this.copy.id ? 'Edit company' : 'Add company'
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }
</style>
